import { useEffect, useMemo } from 'react'

import s from './styles.module.scss'

export default function TallyEmbed({ title = 'Encuesta', formId = 'RGD0Ep', onSubmit }) {
  const baseUrl = `https://tally.so/r/${formId}`

  const src = useMemo(() => {
    const params = new URLSearchParams()
    params.set('transparentBackground', '1')
    params.set('hideTitle', '1')
    return `${baseUrl}?${params.toString()}`
  }, [baseUrl])

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.origin !== 'https://tally.so') return
      if (!e.data) return

      let data
      try {
        data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data
      } catch {
        return
      }

      if (data.event === 'Tally.FormSubmitted') {
        onSubmit?.(data.payload)
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [onSubmit])

  return (
    <div className={s.container}>
      <iframe title={title} src={src} allow="fullscreen; clipboard-read; clipboard-write" className={s.iframe} />
    </div>
  )
}
